import * as aTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';
import * as dt from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

export const stype = (el) => `${aTypes.SEARCH_TYPE}_${el.field}_${el.id}`;

export const uFi = (el) => `${el.field}_${el.id}`;

export const curRefFi = (el) => {
    if (el.params && el.params.profi_search
        && el.params.profi_search.refId) {
        return el.params.profi_search.refId;
    }
    return false;
}

export const uRefFi = (el) => {
    if (curRefFi(el)) {
        return `${el.params.profi_search.refId}_${el.id}`;
    }
    return `${el.field}_${el.id}`;;
}

export const toDateStr = ({ value }) => {
    console.log("LOGS: toDateStr value", value);
    if (typeof value == 'object' && !value.intl) {
        try {
            let tmp = value.setHours(value.getHours() + 2);
            let dateObj = new Date(tmp);
            let nDate = dateObj.toISOString();
            if (nDate.includes("T")) nDate = dt.subStringBefore(nDate, "T");
            console.log("LOGS: Profi nDate", nDate);
            return nDate;
        } catch (e) {
            console.log("LOGS: toDateStr e", e);
            return value;
        }
    }
    return value;
}

export const checkAllFields = ({ fields, item, userInputs, advancedObj }) => {
    let type = advancedObj[`${stype(item)}`] || aTypes.CONTAINS;
    if (item.type === 'datefromto' && type === aTypes.CONTAINS) type = '=';
    if (type && type.value) type = type.value;
    let value = userInputs[`${uFi(item)}`] || '';
    if (typeof value == 'object') value = toDateStr({ value });
    if (value && value.value) value = value.value;

    if (curRefFi(item)) {
        value = userInputs[`${uRefFi(item)}`] || '';
        let field = curRefFi(item);
        if (value && value.includes(";")) {
            fields.push(aTypes.BEGIN_OR)
            value.split(";").forEach(entry => fields.push({ field, type, value: entry }));
            fields.push(aTypes.END_OR)
        } else {
            fields.push({ field, type, value });
        }
    } else {
        fields.push({ "field": item.field, type, value });
    }
    return fields
}


export const isOr = ({ item, advancedObj }) => {
    if (item.type && item.type === aTypes.CONNECTOR
        && advancedObj[item.id] && advancedObj[item.id].value === aTypes.OR) {
        return true;
    }
    return false;
}

export const isGroup = (item) => {
    if (item.type && item.type === aTypes.GROUP
        && item.data && item.data.length) {
        return true;
    }
    return false;
}

export const addObjToArr = ({ fields, idxOf, obj = aTypes.BEGIN_OR }) => {
    let newFields = fields.slice(0, idxOf);
    newFields.push(obj);
    let others = fields.slice(idxOf);
    newFields = [...newFields, ...others];
    fields = [...newFields];
    return fields;
}

export const getIndexOfType = ({ fields, last, sType }) => {
    let grIdx = last[0].grIdx;
    let idxOf = fields.findIndex(field => field.grIdx && field.grIdx == grIdx && field.type == sType);
    return idxOf;
}

export const handleOr = ({ fields }) => {
    if (fields.length == 1) {
        fields = [aTypes.BEGIN_OR, ...fields];
    }
    else {
        let last = fields.splice(fields.length - 1);
        if (!(last[0] && last[0].type == 'END_OR')) {
            if (!(last[0] && last[0].type == 'END_GROUP')) {
                fields.push(aTypes.BEGIN_OR);
                fields.push(last[0]);
            } else {
                let tmp = fields.splice(fields.length - 1);
                if (!(tmp[0] && tmp[0].type == 'END_OR')) {
                    fields.push(aTypes.BEGIN_OR);
                    fields.push(tmp[0]);
                    fields.push(last[0]);
                } else {
                    fields.push(last[0]);
                }
            }
        }
    }
    return fields;
}

export const handleGroup = ({ fields, index, item, userInputs, advancedObj, beginOr }) => {
    let begin_gr = { ...aTypes.BEGIN_GROUP, grIdx: index + 1 }
    fields.push(begin_gr);
    let gFields = convertFields({ inFields: item.data, advancedObj, userInputs });
    if (beginOr && gFields && gFields.length > 0) {
        if (gFields.length == 1) gFields = [gFields[0], aTypes.END_OR];
        else gFields = [gFields[0], aTypes.END_OR, ...gFields.slice(1)];
    }
    fields.push(...gFields);
    let end_gr = { ...aTypes.END_GROUP, grIdx: index + 1 }
    fields.push(end_gr);
    return fields;
}

export const handleFields = ({ fields }) => {
    console.log("LOGS: handleFields", fields);
    fields = fields.map(field => {
        if (field.grIdx) delete field.grIdx;
        return field;
    });
    return fields;
}

export const convertFields = ({ inFields, userInputs, advancedObj }) => {
    let fields = [];
    if (inFields.length > 0) {
        let beginOr = false;
        inFields.forEach((item, index) => {
            if (item.field && item.field !== aTypes.CONNECTOR) {
                fields = checkAllFields({ fields, item, userInputs, advancedObj });
                if (beginOr && beginOr === `${aTypes.CONN}${item.id}`) {
                    fields.push(aTypes.END_OR);
                    beginOr = false;
                }
            }
            if (isOr({ item, advancedObj })) {
                beginOr = item.id;
                fields = handleOr({ fields });
            }
            if (isGroup(item)) {
                fields = handleGroup({ fields, index, item, userInputs, advancedObj, beginOr });
                if (beginOr && (dt.subStringAfter(beginOr, aTypes.CONN)
                    == dt.subStringAfter(item.id, aTypes.PARENTS))) {
                    // fields.push(aTypes.END_OR);
                    beginOr = false;
                }
            }
        })
    }
    fields = handleFields({ fields });
    return fields;
}